/**
 * @file Enum presenting the supported values of the Request.Status property.
 * @author Tom Verschoore de la Houssaije.
 */
/**
 * Enum presenting the supported values of the Request.Status property.
 * @export
 * @enum {string}
 */
export var RequestStatus;
(function (RequestStatus) {
    /**
     * Starting status when Request is created.
     * This is the only not final state of a Request.
     */
    RequestStatus["Request"] = "REQUEST";
    /**
     * Status of request when Recipient has accepted the Request.
     * This is a final state of a Request.
     */
    RequestStatus["Accept"] = "ACCEPT";
    /**
     * Status of request when Recipient has declined the Request.
     * This is a final state of a Request.
     */
    RequestStatus["Decline"] = "DECLINE";
    /**
     * Status of request when Sender has withdrawn his request.
     * This is a final state of a Request.
     */
    RequestStatus["Withdrawn"] = "WITHDRAWN";
    /**
     * Status of a request that competed, for the same plan items, with another accepted request.
     * This is a final state of a Request.
     */
    RequestStatus["Conflict"] = "CONFLICT";
})(RequestStatus || (RequestStatus = {}));
